export const STATUS_LABELS = {
  ATIVO: "Ativo",
  INATIVO: "Inativo",
  PROSPECTO: "Prospecto",
};

export function statusColor(status) {
  switch (status) {
    case "ATIVO":
      return "bg-emerald-100 text-emerald-700 border-emerald-200";
    case "INATIVO":
      return "bg-slate-100 text-slate-600 border-slate-200";
    case "PROSPECTO":
      return "bg-amber-100 text-amber-700 border-amber-200";
    default:
      return "bg-slate-100 text-slate-600 border-slate-200";
  }
}

export function msgStatusColor(status) {
  switch (status) {
    case "ENVIADA":
      return "bg-emerald-100 text-emerald-700 border-emerald-200";
    case "PENDENTE":
      return "bg-amber-100 text-amber-700 border-amber-200";
    case "ERRO":
      return "bg-red-100 text-red-700 border-red-200";
    case "CANCELADA":
      return "bg-slate-100 text-slate-500 border-slate-200";
    default:
      return "bg-slate-100 text-slate-600 border-slate-200";
  }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return "—";
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "—";
  }
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").slice(0, 2).map((n) => n[0]).join("").toUpperCase();
}
